import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, inject, NgModule } from '@angular/core';

@Component({
  selector: 'app-contrast-provider',
  template: `<ng-content></ng-content>`,
  host: {
    class: 'absolute inset-0 data-[state=grayscale]:grayscale data-[state=invert]:grayscale data-[state=invert]:invert',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContrastProviderComponent {
  private cdr = inject(ChangeDetectorRef);
  states = ['normal', 'grayscale', 'invert'] as const;

  @HostBinding('attr.data-state')
  state: typeof this.states[number];

  constructor() {
    this.reset();
  }

  change() {
    this.state = this.states[(this.states.indexOf(this.state) + 1) % this.states.length];
    this.cdr.markForCheck();
  }

  reset() {
    this.state = this.states[0];
    this.cdr.markForCheck();
  }
}

@NgModule({
  declarations: [ContrastProviderComponent],
  exports: [ContrastProviderComponent],
  imports: [CommonModule],
})
export class ContrastProviderModule {}
